import React, { useMemo } from 'react';
import { useAppSelector, useHistory, useLocation, useQueryParamValue } from 'src/utils/Hooks';
import { AppFilterModal } from 'src/components/BeaconV2Components/common/AppFilterButton/AppFilterModal';
import { AtlasFilterModal } from 'src/components/AtlasV2Components/AtlasFilterModal/AtlasFilterModal';
import { AppName } from 'sl-api-connector/types';
import { BEACON_SUBTABS } from 'src/components/BeaconV2Components/GenericSidebarNav/useBeaconRoutes';
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import { useAppFilterModalStore } from 'src/zustandStores/BeaconPro/AppFilterStore';
import { getAppName } from 'src/utils/app';

export const AppFilterButton = () => {
  const history = useHistory();
  const location = useLocation();
  const filterParams = new URLSearchParams(location.search);
  const { subtab } = useAppSelector((state) => state.app.queryParams);

  // if we are in the plan page, the default filter for adjustmentStatus is published and draft, and we don't want to have dots.
  const isForecastAdjustmentTab =
    filterParams.has('adjustmentStatus') && subtab === BEACON_SUBTABS.FORECAST_ADJUSTMENTS;

  const { isOpen, openModal, closeModal } = useAppFilterModalStore();
  const appName = getAppName();

  /**
   * Checks url for current filter
   */
  const filterActive: boolean = useMemo(() => {
    return filterParams.has('filter') || isForecastAdjustmentTab;
  }, [filterParams, isForecastAdjustmentTab]);

  const handleClose = () => {
    closeModal();
  };

  return (
    <>
      <SlButton
        active={filterActive}
        variant="normal"
        onClick={() => openModal()}
        buttonSx={{
          paddingX: '9px'
        }}
      >
        Filter
      </SlButton>
      {appName === AppName.Atlas ? (
        <AtlasFilterModal history={history} location={location} open={isOpen} handleClose={handleClose} />
      ) : (
        <AppFilterModal history={history} location={location} open={isOpen} handleClose={handleClose} />
      )}
    </>
  );
};
